import Vue from "vue"
import VueRouter from "vue-router"

import DynamicPage from "@/pages/Dynamic"

import store from "@/store"

import scrollBehavior from "@/plugins/router/scroll-behaviour"
import { BUY_PATH } from "@/lib/checkout-utils"

Vue.use(VueRouter)

const MANAGED_PAGE_PREFIX = "/me/"

const requireAuthenticationHook = (to, from, next) => {
  if (store.getters["access/requiresAuthentication"]) {
    return requireAuthentication(to, from, next)
  } else {
    return next()
  }
}

// show auth modal slower first time to prevent auth modal popping up for
// public pages
let hackyAuthCounter = 0

const requireAuthentication = (to, from, next) => {
  if (
    store.getters["access/allowsAnonymousBrowsing"] &&
    !to.path.startsWith(MANAGED_PAGE_PREFIX)
  ) {
    // vLink will handle showing the auth modal
    return next()
  }

  if (store.getters["auth/hasCheckedAuthentication"]) {
    hackyAuthCounter++

    return store.getters["auth/isAuthenticated"] ||
      to.hash.startsWith("#auth") ||
      from.hash.startsWith("#auth")
      ? next()
      : hackyAuthCounter === 1
      ? setTimeout(() => next("#auth"), 250)
      : next("#auth")
  } else {
    setTimeout(() => requireAuthentication(to, from, next), 250)
    return next()
  }
}

const routes = [
  {
    path: `${MANAGED_PAGE_PREFIX}account`,
    component: () => import("@/pages/Account"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}account/details`,
    component: () => import("@/pages/account/Details"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}account/purchases`,
    component: () => import("@/pages/account/Purchases"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}products/:id`,
    component: () => import("@/pages/PurchasedProduct"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}account/notifications`,
    component: () => import("@/pages/account/Notifications"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}account/subscriptions`,
    component: () => import("@/pages/account/Subscriptions"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}account/support`,
    component: () => import("@/pages/account/Support"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}account/privacy`,
    component: () => import("@/pages/account/Privacy"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}messages/new`,
    component: () => import("@/pages/MessageThread/New")
    // beforeEnter: requireAuthentication // Causing issues not having route params available
  },
  {
    path: `${MANAGED_PAGE_PREFIX}messages/:id`,
    component: () => import("@/pages/MessageThread/Show")
    // beforeEnter: requireAuthentication // Causing issues not having route params available
  },
  {
    path: `${MANAGED_PAGE_PREFIX}messages`,
    component: () => import("@/pages/MessageThread/Index")
    // beforeEnter: requireAuthentication // Causing issues not having route params available
  },
  {
    path: `${MANAGED_PAGE_PREFIX}messages/:id/participants`,
    component: () => import("@/pages/MessageThread/Participants")
    // beforeEnter: requireAuthentication // Causing issues not having route params available
  },
  {
    path: "/me/schedule",
    component: () => import("@/pages/Schedule")
  },
  {
    path: "/discover/programs",
    component: () => import("@/pages/Discover")
  },
  {
    path: "/discover/events",
    component: () => import("@/pages/Discover")
  },
  {
    path: "/discover/packs",
    component: () => import("@/pages/Discover")
  },
  {
    path: `${MANAGED_PAGE_PREFIX}my-content`,
    component: () => import("@/pages/MyContent"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}submissions/:formType?`,
    component: () => import("@/pages/submissions/SubmissionsNumber"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}forms/:formId/submissions/:id`,
    component: () => import("@/pages/submissions/FormSubmission"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}forms/:formId/submissions`,
    component: () => import("@/pages/submissions/FormSubmissions"),
    beforeEnter: requireAuthentication
  },
  {
    path: `${MANAGED_PAGE_PREFIX}workout/:id/sessions`,
    component: () => import("@/pages/workout/Sessions"),
    beforeEnter: requireAuthentication
  },
  {
    path: "/forms/:id",
    component: () => import("@/pages/Form")
  },
  {
    path: `${BUY_PATH}:ids`,
    component: () => import("@/pages/Buy")
  },
  {
    path: "/subscriber/:id/unsubscribe",
    component: () => import("@/pages/UnsubscribeFromEmail")
  },

  // Redirects
  {
    path: "/discover",
    redirect: "/discover/programs"
  },

  // Account App Pages
  {
    path: "*",
    component: DynamicPage
  }
]

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior
})

router.beforeEach(requireAuthenticationHook)

export default router
